import CloseBig from 'assets/icons/CloseBig';
import Image from 'components/Image';
import React from 'react';
import { above } from 'utils/mediaqueries';
import colors from 'config/theme/colors';
import styled from 'libs/styled';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import useClientHeight from 'hooks/useClientHeight';
import useHeaderHeights from 'hooks/useHeaderHeights';
import zIndex from 'config/theme/z-index';

// Same position and size as BasketOverlay, so that the two overlays behave identically
const TransitionElement = styled('div', {
    shouldForwardProp: prop => ['clientHeight', 'headerHeights'].indexOf(prop) === -1,
})`
    position: absolute;
    top: ${({ headerHeights }) => headerHeights.mobile}px;
    height: ${({ clientHeight, headerHeights }) => `calc(${clientHeight} - ${headerHeights.mobile}px)`};
    width: 100vw;

    ${above.md} {
        position: fixed;
        right: 0;
        top: ${({ headerHeights }) => headerHeights.desktop}px;
        width: 40vw;
        max-width: 960px;
        height: ${({ clientHeight, headerHeights }) => `calc(${clientHeight} - ${headerHeights.desktop}px)`};
    }
`;

// The full height together with the background covers the area that the image does not fill
const Wrapper = styled('div')`
    position: relative;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    background-color: ${colors.background};
`;

const Icon = styled('button')`
    position: absolute;
    top: 16px;
    right: 12px;

    ${above.md} {
        top: 24px;
        right: 24px;
    }
`;

const HarmonisationOverlay = () => {
    const { t } = useTranslation();
    const overlay = useSelector(state => state.overlay);
    const harmonisationImage = useSelector(state => state.header.data.basket?.harmonisationImage) || {};
    const hasHarmonisationImage = Boolean(harmonisationImage.url);
    const headerHeights = useHeaderHeights();
    const clientHeight = useClientHeight();

    // The overlay state only holds one overlay at a time, so re-open the basket the user came from
    const closeOverlay = () => {
        overlay.show('basketOverlay', {
            transparent: false,
            zIndex: zIndex.basket,
            isUpsell: false,
        });
    };

    return (
        <TransitionElement className="slide-in right" clientHeight={clientHeight} headerHeights={headerHeights}>
            <Wrapper>
                {hasHarmonisationImage && (
                    <Image
                        alt={harmonisationImage.alt || harmonisationImage.title || ''}
                        display="block"
                        height="auto"
                        imageBackground={colors.background}
                        loading="eager"
                        sizes={['100vw', null, 'min(40vw, 960px)']}
                        src={{ url: harmonisationImage.url, width: [480, 768, 960, 1440, 1920] }}
                        width="100%"
                    />
                )}
                <Icon aria-label={t('checkout_basket.back_to_basket')} type="button" onClick={closeOverlay}>
                    <CloseBig aria-hidden="true" color={hasHarmonisationImage ? colors.white : colors.black} />
                </Icon>
            </Wrapper>
        </TransitionElement>
    );
};

export default HarmonisationOverlay;
